module.exports = __webpack_public_path__ + "static/img/invite-banner.cf0080ff.jpeg";